import axios from 'axios';

const publicHttp = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 15000,
    headers: { 'Content-Type': 'application/json' },
});

export const customerSearchRequest = async (data) => {
    return await publicHttp.post('customerSearch/search', data)
        .then(res => res.data)
        .catch(err => ({ error: err.response?.data?.message || err.message }));
};
